// Client wrapper for the Worker's /api/all-records endpoint.

export type RecordEntry = {
  type: string;
  status: "ok" | "nxdomain" | "timeout" | "error" | "servfail";
  records: string[];
  message?: string;
  ad?: boolean;
};

export type AllRecordsReport = {
  domain: string;
  entries: RecordEntry[];
  present: string[];
  nxdomain: boolean;
};

export async function fetchAllRecords(host: string, signal?: AbortSignal): Promise<AllRecordsReport> {
  const res = await fetch(`/api/all-records?host=${encodeURIComponent(host)}`, { signal });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as any).error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as AllRecordsReport;
}
